import { render, staticRenderFns } from "./venue.vue?vue&type=template&id=901118a8&scoped=true"
import script from "./venue.vue?vue&type=script&lang=js"
export * from "./venue.vue?vue&type=script&lang=js"
import style0 from "./venue.vue?vue&type=style&index=0&id=901118a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901118a8",
  null
  
)

export default component.exports